import axios from "axios";
import Links from "../constants/Links";



/**
 * This is the Standalone API hook, for handling standalone payments in the system (C) 2021-2023
 */



const SchoolFees = {
    /**
     * @description Creates a fee item title
     * @param {object} data object containing the following properties: title
     * @returns {Promise<object>} the created object
     */
    createTitle: async(data) => {
        return axios.post(Links.schoolFees.createTitle, data)
    },


    /**
     * @description Updates a fee item title
     * @param {string} id ID of the title to update
     * @param {object} data object containing the following properties: title
     * @returns {Promise<object>} the updated object
     */
     updateTitle: async(id, data) => {
        return axios.put(Links.schoolFees.updateTitle + '/' + id, data)
    },

    /**
     * @description Fetches all titles
     * @returns {Promise<any[]>} List of fee titles
     */
    allTitle: async () => {
        return axios.get(Links.schoolFees.fetchTitles)
    },

    /**
     * @description Makes an item invincible from invoice items
     * @param {string} id the id of the item
     * @returns {Promise<object>} the modified fee item
     */
    toggleHidden: async(id) => {
        return axios.put(Links.schoolFees.toggleHidden + '/' + id)
    },

    /**
     * @description Makes an item a late payment item
     * @param {string} id the id of the item
     * @returns {Promise<object>} the modified fee item
     */
    toggleLatePayment: async(id) => {
        return axios.put(Links.schoolFees.toggleLatePayment + '/' + id)
    },

    /**
     * @description Creates a new fee item
     * @param  data  an object containing the following:
     * titleId: fee item title ID,
     * sessionId: ID of the session ,
     * stateType: 1 for indigene, 2 for Non indigene and 3 for both. the user selects the option,
     * amount: Amount for the item,
     * fee: 1 for school fee. it should be an option. for now there exists only one option,
     * faculty: ID of faculty to support
     * department: ID of department to support,
     * programme: ID of programme this item supports,
     * level: ID of level this item supports,
     * modeOfEntryId: ID of the mode of entry this item should support. select nothing for all modes of entry,
     * latePaymentItem: True of False. marks whether this item should be treated as a late payment item
     * @returns the newly created item
     */
    // createNewFeeItem: async (data) => {
    //     return axios.post(Links.schoolFees.createItem, data);
    // },


    /**
     * @description Creates a new fee item
     * @param {object} data  an object containing the following:
     * titleId: fee item title ID,
     * sessionId: ID of the session,
     * stateType: 1 for indigene, 2 for Non indigene and 3 for both. the user selects the option,
     * amount: Amount for the item,
     * feeType: 1 for school fee. it should be an option. for now there exists only one option,
     * faculty: ID of faculty to support,
     * department: ID of department to support,
     * programme: ID of programme this item supports,
     * level: ID of level this item supports,
     * studentCategory: Category of students. 1 for applicants and 2 for returning students and null for both
     * latePaymentItem: True of False. marks whether this item should be treated as a late payment item
     * @returns {Promise<object>} the newly created item
     */
     createNewFeeItem: async (data) => {
        return axios.post(Links.schoolFees.createItem, data);
    },

    /**
     * @description Updates a new fee item
     * @id ID of the fee item to update
     * @param {object} data  an object containing the following:
     * titleId: fee item title ID,
     * sessionId: ID of the session ,
     * stateType: 1 for indigene, 2 for Non indigene and 3 for both. the user selects the option,
     * amount: Amount for the item,
     * feeType: 1 for school fee. it should be an option. for now there exists only one option,
     * faculty: ID of faculty to support,
     * department: ID of department to support,
     * programme: ID of programme this item supports,
     * level: ID of level this item supports,
     * studentCategory: Category of students. 1 for applicants and 2 for returning students and null for both
     * latePaymentItem: True of False. marks whether this item should be treated as a late payment item
     * @returns {Promise<object>} the newly updated item
     */
     updateFeeItem: async (id, data) => {
        return axios.put(Links.schoolFees.updateItem + '/' + id, data);
    },


    /**
     * @description Deletes a fee item
     * @param {string} itemId  id of the fee item to deletee
     * @returns {Promise<object>}
     */
    deleteItem: async (itemId) => {
        return axios.delete(Links.schoolFees.deleteItem + itemId)
    },

    /**
     * @description Fetches fee for session and/or other params
     * @param {string} session the session id. this is required
     * @param {string} faculty the faculty id. optional
     * @param {string} department department id: optional
     * @param {string} programme progtamme id. optional
     * @param {string} level level id. optional
     * @param {string} category category of students. 1 for applicants, 2 for returning students and null for both, optional
     * @param {string} indigene 1 for indigene and 2 for non indigene. null is for both. optional
     * @returns {Promise<any[]>}
     */
    fetchAllItems: async (session, faculty, department, programme, level, category, indigene, semester) => {
        return axios.get(
            Links.schoolFees.fetchItems + '?session=' + session + (faculty ? '&faculty=' + faculty : '')
                + (department ? '&department=' + department : '')
                + (programme ? '&programme=' + programme : '')
                + (level ? '&level=' + level : '')
                + (category ? '&category=' + category : '')
                + (indigene ? '&indigene=' + indigene : '')
                + (semester ? '&semester=' + semester : '')
        )
    },

    /**
     * @deprecated
     * @param {string} programmeTypeid the selected programmetype id
     * @param {string} sessionId the selected session id
     * @returns
     */
    allProgrammeType: async (programmeTypeid, sessionId) => {
        return axios.get(Links.schoolFees.allProgrammeType + programmeTypeid + '/' + sessionId)
    },

    /**
     * @deprecated
     * @param {string} programmeTypeid the selected programmetype id
     * @param {string} sessionId the selected session id
     * @param {string} levelId the selected level id
     * @returns
     */
    allLevel: async (programmeTypeid, sessionId, levelId) => {
        return axios.get(Links.schoolFees.allProgrammeType + programmeTypeid + '/' + sessionId + '/' + levelId)
    },

    /**
     * fetch all fees for a specific student
     * @param {string} session the selected session id
     * @param {string} student the selected student id
     * @returns
     */
    getFeeFor: async (session, student, semester) => {
        return axios.get(Links.schoolFees.getFeeFor + '?session=' + session + '&user=' + student + (semester ? ('&semester=' + semester) : ''))
    },

    /**
     * initiate payment standalone
     * @param {object} data the required information needed
     * @returns {Promise<object>}
     */
    initializePayment: async (data) => {
        return axios.post(Links.schoolFees.initializePayment, data)
    },

    /**
     * handles transaction refreshing i.e to check if a transaction was successful
     * @param {string} paymentId the payment id of the transaction
     * @returns {Promise<object>}
     */
    refreshTransaction: async (paymentId) => {
        return axios.put(Links.schoolFees.refreshTransaction + paymentId);
    },

    /**
     * handles verification of standalone payment
     * @param {string} transactionId transaction number to be verified
     * @returns {Promise<object>}
     */
    verifyTransaction: async (transactionId) => {
        return axios.put(Links.schoolFees.verifyTransaction + transactionId);
    },

    /**
     * copy session using the copy button
     * @param {string} session
     * @returns {Promise<object>}
     */
    copyItems: async (session) => {
        return axios.put(Links.schoolFees.copyItems + session)
    },

    /**
     * fetch all reports for the faculty depending on the selected programmetype, faculty and session
     * @param {string} programme_type the seleected programme_type id
     * @param {string} faculty the selected faculty id
     * @param {string} session the selected session id
     * @returns {Promise<any[]>}
     */
    reportForFaculty: async (programme_type, faculty, session) => {
        return axios.get(Links.schoolFees.reportForFaculty + "?programme_type="+programme_type + "&faculty=" + faculty + "&session=" + session)
    },

    // delete: async (itemId) => {
    //     return axios.put(Links.schoolFees.deleteItem + itemId)
    // },

    /**
     * fetch invoice base on the entered invoice number
     * @param {string} invoice invoice number
     * @returns {Promise<Blob>}
     */
    invoice: async (invoice) => {
        return axios.get(Links.schoolFees.invoice + '?invoice=' + invoice, {
            responseType: "blob"
        })
    },

    /**
     * @description View reports
     * @param {string} reqParams  an object containing the following:
     * session,
     * payment(min 1 and max 6),
     * startDate(yyyy-mm-dd) and endDate(yyyy-mm-dd)
     * session and payment are required while the others are optional
     * @param {string} page the page to fetch
     * @param {string} size the size of the page
     * @returns {Promise<any[]>}
     */
    report: async (reqParams, page, size) => {
        let params = '?session=' + reqParams.session
        params = params + '&payment=' + reqParams.payment
        if(reqParams.startDate){
            params = params + '&start_date=' + reqParams.startDate
        }

        if(reqParams.endDate){
            params = params + '&end_date=' + reqParams.endDate
        }

        if(reqParams.semester){
            params = params + '&semester=' + reqParams.semester
        }

        return axios.get(Links.schoolFees.report + params + '&page=' + page + '&size=' + size)
    },

    /**
     * @description Donwloads reports  in xlsx format
     * @param {string} reqParams  an object containing the following: session, p
     * payment(min 1 and max 6), startDate(yyyy-mm-dd) and endDate(yyyy-mm-dd)
     * session and payment are required while the others are optional
     * @returns {Promise<Blob>}
     */
     downloadReport: async (reqParams) => {
        let params = '?session=' + reqParams.session
        params = params + '&payment=' + reqParams.payment
        if(reqParams.startDate){
            params = params + '&start_date=' + reqParams.startDate
        }

        if(reqParams.endDate){
            params = params + '&end_date=' + reqParams.endDate
        }

        if(reqParams.semester){
            params = params + '&semester=' + reqParams.semester
        }

        return axios.get(Links.schoolFees.downloadReport + params, {
            responseType: 'blob'
        })
    },

    /**
     * clear batch payments
     * @param {object} data
     * @returns {Promise<object>}
     */
    clearBatch: async (data) => {
        return axios.post(Links.schoolFees.clearBatch, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
            timeout: 1000 * 60 * 5
        });
    },


    /**
     * @description - send the standalone name
     * @returns {Promise<object>} true
     */
    fetchStandAloneTitle: async()  => {
        return axios.get(Links.schoolFees.standAloneTitles);
    },

    /**
     * @description Fetches fee for session and/or other params
     * @param {string} session the session id. this is required
     * @param {string} faculty the faculty id. optional
     * @param {string} department department id: optional
     * @param {string} programme progtamme id. optional
     * @param {string} level level id. optional
     * @param {string} category category of students. 1 for applicants, 2 for returning students and null for both, optional
     * @param {string} indigene 1 for indigene and 2 for non indigene. null is for both. optional
     * @returns {Promise<any[]>}
     */
    fetchAllStandaloneItems: async (session, semester, faculty, department, programme, level, category, indigene) => {
        return axios.get(
            Links.schoolFees.fetchStandeloneItems + '?session=' + session + (faculty ? '&faculty=' + faculty : '')
            + (department ? '&department=' + department : '')
            + (programme ? '&programme=' + programme : '')
            + (level ? '&level=' + level : '')
            + (category ? '&category=' + category : '')
            + (indigene ? '&indigene=' + indigene : '')
            + (semester ? '&semester=' + semester : '')
        )
    },

    /**
     * @description - create a new standalone fee
     * @param {object} data
     * @returns {Promise<object>}
     */
    createStandalone(data) {
        return axios.post(Links.schoolFees.createStandalone, data)
    },

    /**
     * @description - update the new standalone fee
     * @param {string} id the id of the standalone payment to be deleted
     * @param {object} data the data to be updated
     * @returns {Promise<object>}
     */
    updateStandalone(id, data) {
        return axios.put(Links.schoolFees.updateStandalone + '/' + id, data)
    },

    /**
     * @description - delete the standalone fee base on id
     * @param {string} id the id of the standalone payment to deleted
     * @returns {Promise<object>}
     */
    deleteStandalone(id){
        return axios.delete(Links.schoolFees.deleteStandalone + '/' + id)
    },

    /**
     * fetch standalone payment for user on the system
     * @param {string} session the selected session for the standalone payment
     * @param {object} user the user the the standalone payment is for
     * @returns {Promise<any[]>}
     */
    standaloneForUser(session, user){
        return axios.get(Links.schoolFees.standaloneForStudent + "?session=" + session + "&user=" + user)
    },

    excludeFaculties(itemId, faculties){
        return axios.post(Links.schoolFees.excludeFaculties, {
            itemId: itemId,
            faculties: faculties
        })
    }
}

export default SchoolFees
